var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',_vm._b({staticClass:"im-input",class:{'disabled': _vm.disabled},attrs:{"type":"text","clearable":_vm.clearable,"size":"small"},on:{"keyup":_vm.keyup,"change":_vm.change,"focus":_vm.focus,"blur":_vm.blur},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},'el-input',{..._vm.$props, ..._vm.$attrs},false))
}
var staticRenderFns = []

export { render, staticRenderFns }